import React from 'react';
import Styles from 'components/footer/Footer.module.scss';

interface FooterProps {
  isVisible?: boolean;
}

const Footer: React.FC<FooterProps> = ({ isVisible = true }) => (
  <div className={`${Styles.footer} ${isVisible ? Styles.visible : Styles.hidden}`}>
    <p className="mb-0 text-white fontTwenty font-weight-600 ">© 2025. All Rights Reserved.</p>
  </div>
);
export default Footer;
